import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cdba02c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#"
}, "全部 >", -1));

const _hoisted_3 = {
  class: "course-list"
};
const _hoisted_4 = {
  key: 0,
  class: "no-data",
  style: {
    "margin-bottom": "40px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_SectionContainer = _resolveComponent("SectionContainer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_SectionContainer, {
    title: "精品课程",
    bg: `linear-gradient(180deg, var(--el-color-primary) 0%, var(--el-color-primary-light-8) 100%)`
  }, {
    action: _withCtx(() => [_hoisted_2]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList($data.homeCourseList, course => {
      return _openBlock(), _createBlock(_component_CourseCard, {
        info: course,
        key: course.courseId,
        "show-label": true,
        userInfo: $props.userInfo,
        authType: $data.authType
      }, null, 8, ["info", "userInfo", "authType"]);
    }), 128)) : _createCommentVNode("", true)]), $data.homeCourseList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["bg"])]);
}